import { render } from "./ResetPasswordSuccessful.vue?vue&type=template&id=7d56afc6"
import script from "./ResetPasswordSuccessful.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSuccessful.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__